export const KeycloakRoles = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  HAS_VIEW_DETAILS_ACCESS: 'HAS_VIEW_DETAILS_ACCESS',
  HAS_VIEW_RECORD_STATUS: 'HAS_VIEW_RECORD_STATUS',
  HAS_APPROVE_ACCESS: 'HAS_APPROVE_ACCESS',
  HAS_REVOKE_ACCESS: 'HAS_REVOKE_ACCESS',
  HAS_BULK_UPLOAD_ACCESS: 'HAS_BULK_UPLOAD_ACCESS',
  HAS_VIEW_ALL_RECORDS: 'HAS_VIEW_ALL_RECORDS',
  HAS_CHECK_APPLICATION_STATUS: 'HAS_CHECK_APPLICATION_STATUS',
  HAS_EDIT_RECORD_ACCESS: 'HAS_EDIT_RECORD_ACCESS',
  HAS_VIEW_APOR_TYPE_ACCESS: 'HAS_VIEW_APOR_TYPE_ACCESS',
  HAS_ADD_APOR_TYPE_ACCESS: 'HAS_ADD_APOR_TYPE_ACCESS',
  HAS_UPDATE_APOR_TYPE_ACCESS: 'HAS_UPDATE_APOR_TYPE_ACCESS',
  HAS_DELETE_APOR_TYPE_ACCESS: 'HAS_DELETE_APOR_TYPE_ACCESS',
  HAS_UPDATE_DEVICE_RECORD_ACCESS: 'HAS_UPDATE_DEVICE_RECORD_ACCESS',
  HAS_ADD_DEVICE_RECORD_ACCESS: 'HAS_ADD_DEVICE_RECORD_ACCESS',
  HAS_VIEW_DEVICE_RECORD_ACCESS: 'HAS_VIEW_DEVICE_RECORD_ACCESS',
  HAS_DELETE_DEVICE_RECORD_ACCESS: 'HAS_DELETE_DEVICE_RECORD_ACCESS',
  HAS_SEARCH_DEVICE_RECORD_ACCESS: 'HAS_SEARCH_DEVICE_RECORD_ACCESS',
};

export default KeycloakRoles;
